import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useDayRentalBasicRateSubmit from "hooks/useDayRentalBasicRateSubmit";
import DynamicDayRentalInput from "components/form/DynamicDayRentalInput";
import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";

import React from "react";
import Scrollbars from "react-custom-scrollbars-2";

const DayRentalBasicRateDrawer = ({ id }) => {
  const {
    setSelectedOptions,
    selectedOptions,
    handleVehicleCategoryChange,
    setDataInput,
    dataInput,
    handleChangeInput,
    register,
    handleSubmit,
    selectedCity,
    onSubmit,
    handleCityChange,
    selectedVehicleCategory,
    trigger,
    errors,
    loading,primeAvailable
  } = useDayRentalBasicRateSubmit(id);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title title={"Edit Day Rental Basic Rate"} description={""} />
        ) : (
          <Title title={"Add Day Rental Basic Rate"} description={""} />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-4 flex-grow scrollbar-hide w-full max-h-full pb-40">
            <div className="grid grid-cols-12 gap-6 mb-6">
              <div className="col-span-6">
                <LabelArea label={"City"} />
                <SelectSingleCityOnly
                  register={register}
                  label="City"
                  name="city"
                  type="text"
                  placeholder={"--Choose--"}
                  selectedCity={selectedCity}
                  handleCityChange={handleCityChange}
                />
                <Error errorName={errors.city} />
              </div>
              <DynamicDayRentalInput
                register={register}
                trigger={trigger}
                errors={errors}
                dataInput={dataInput}
                setDataInput={setDataInput}
                handleChange={handleChangeInput}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                handleVehicleCategoryChange={handleVehicleCategoryChange}
                selectedVehicleCategory={selectedVehicleCategory}
                primeAvailable={primeAvailable}
              />
            </div>
          </div>

          <DrawerButton
            isSubmitting={loading}
            id={id}
            title={id ? "Update" : "Submit"}
          />
        </form>
      </Scrollbars>
    </>
  );
};

export default DayRentalBasicRateDrawer;
